(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('poActionsCustomerConfig', poActionsCustomerConfig);

	poActionsCustomerConfig.$inject = ['$rootScope', '$scope', '$timeout', '$experiments'];

	function poActionsCustomerConfig($rootScope, $scope, $timeout, $experiments) {
		var vm = this;
		vm.showAddCriticalityLevel = true;

		$scope.type = 'customer';
		$scope.siteId = globalConfig.factory.id;
		$scope.customerId = globalConfig.customer.id;
	}
})();